// .storybook/theme.js

import { create } from '@storybook/theming'

export default create({
  base: 'light',
  brandTitle: 'Sauce UI',
  brandImage: 'https://www.spglobal.com/_assets/images/marketintelligence/logo-mi.png'
})
